(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-before-after"] && !window.DesignMode) return;
  try {
    

  jQuery(".twentytwenty-container").each(function( index ) {
    jQuery(this).twentytwenty({
      before_label: jQuery(this).find('img.before').data('label'),
      after_label: jQuery(this).find('img.after').data('label')
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-collection"] && !window.DesignMode) return;
  try {
    
  jQuery('.block-collection .product-grid').not('.slick-initialized').slick({
    arrows: true,
    dots:false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          touchMove: true
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-custom-refresh-bundles"] && !window.DesignMode) return;
  try {
    
  jQuery('.block-collection .product-grid').not('.slick-initialized').slick({
    arrows: true,
    dots:false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          touchMove: true
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-custom-refresh-skinny"] && !window.DesignMode) return;
  try {
    
  jQuery('.block-collection .product-grid').not('.slick-initialized').slick({
    arrows: true,
    dots:false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          touchMove: true
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-holiday-gift-guide"] && !window.DesignMode) return;
  try {
    
  jQuery('[data-gift-guide-nav]').slick({
    arrows: false,
    dots: false,
    infinite: false,
    swipeToSlide: true,
    slidesToShow: 1.6,
    slidesToScroll: 1
  });

  if (jQuery(window).width() > 992) {
    jQuery('[data-gift-guide-nav]').slick('unslick')
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-row"] && !window.DesignMode) return;
  try {
    
  jQuery('.collection-row .carousel').slick({
    arrows: true,
    slidesToShow: 4,
    dots:false,
    infinite: false,
    touchMove: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          dots:true
        }
      }
    ]
  });
  
  jQuery('[buy-bundle]').on('click', function(evt) {
    evt.preventDefault();
    
    let formData = { 'items': []};
    let variants = String(jQuery(this).data('variants'));

    if( variants.includes(',') ) {
      variants = variants.split(',');
      variants.forEach((item) => {
        formData['items'].push( { 'id': item, 'quantity': 1 } );
      });
    } else {
      formData['items'].push( { 'id': variants, 'quantity': 1 } );
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      liquidAjaxCart.update();
      // MiniCart.notifyUser(true);
      // data['items'].forEach((item) => { Shopify.onItemAdded(item); });
    })
    .catch((error) => {
      // Shopify.onError('Error:', error);
    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-grid"] && !window.DesignMode) return;
  try {
    
  var content_grid_carousel = jQuery('.content-grid.carousel .row');
  var carousel_display = content_grid_carousel.data('slider-display');
  if(content_grid_carousel.length > 0 ) {
    if(carousel_display == 'all' || ( carousel_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      content_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: content_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: content_grid_carousel.data('slider-arrows'),
        dots: content_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1                                                                             
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-store-locator"]) return;
  try {
    
$(document).ready(function() {
$(".designator-container").hide();
$("section.collection-template div.jumbotron").hide();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-antioxidants"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-glycolic-acid"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-hyaluronic-acid"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-lipodrone"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-niacinamide"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-oat"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-octapeptide"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-path-3"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-peptides"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-perlite"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-phytoene-phytofluene"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-retinol"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-silver-mushroom"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-tranexamic-acid"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-trihex"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks-zinc-oxide"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-featured-blocks"]) return;
  try {
    
  jQuery('.featured-item-container').not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: true,
          slidesToShow: 4,
          touchMove: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          dots: true,
          slidesToShow: 3,
          touchMove: true
        }
      },
      {
        breakpoint: 570,
        settings: {
          dots: true,
          slidesToShow: 2,
          touchMove: true
        }
      },
      {
        breakpoint: 420,
        settings: {
          infinite: false,
          dots: true,
          slidesToShow: 1.5,
          touchMove: true
        }
      }  
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-cart-v2"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      


      observer.unobserve(cartProductRecommendations);
      const url = cartProductRecommendations.dataset.url;
      fetch(url).then((response) => response.text()).then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          cartProductRecommendations.innerHTML = recommendations.innerHTML;
        }
        cartProductRecommendations.querySelectorAll('.cart-item button[data-bs-toggle]').forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
          });
        });
      }).catch((e) => {
        console.error(e);
      });
    };

    const cartProductRecommendations = document.querySelector('.cart-product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(cartProductRecommendations);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-cart"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(cartProductRecommendations);

    const url = cartProductRecommendations.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          cartProductRecommendations.innerHTML = recommendations.innerHTML;
        }

       // MiniCart.init(); [CART-MIG]
        cartProductRecommendations.querySelectorAll('.cart-item button[data-bs-toggle]').forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
          });
        });
      })
      .catch((e) => {
        console.error(e);
      });
    // if ($('.afterpay-paragraph').length) {
    //   let afterPay = $('p.afterpay-paragraph');
    //   $(afterPay).insertAfter('form[action="/cart"] button.btn.btn-primary');
    // }
  };

  const cartProductRecommendations = document.querySelector('.cart-product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
  observer.observe(cartProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
